<script lang="ts">
import StatsBanner from '@/components/banners/StatsBanner.vue'
import QuickLinksCard from '@/components/cards/QuickLinksCard.vue'
import BannerLayoutProvider from '@/components/sections/Banner/BannerLayoutProvider.vue'
import HomeSection from '@/components/sections/HomeSection.vue'
import LatestWinnersSection from '@/components/sections/LatestWinnersSection.vue'
import ProductOverviewSection from '@/components/sections/ProductOverviewSection.vue'
import SponsorshipSection from '@/components/sections/SponsorshipSection.vue'
import WinnersSection from '@/components/sections/WinnersSection.vue'
import { useRouteMeta } from '@/plugins/useRouteMeta'
import { useFaqStore } from '@/stores/faq'
import type { Campaign, Nullable } from '@/types'
import { Themes } from '@/utils/helper-objects'
import FaqView from '@/views/faq/FaqView.vue'
import { defineComponent } from 'vue'

/**
 * The "Home" page.
 */
export default defineComponent({
  components: {
    BannerLayoutProvider,
    FaqView,
    HomeSection,
    ProductOverviewSection,
    QuickLinksCard,
    SponsorshipSection,
    StatsBanner,
    WinnersSection,
    LatestWinnersSection,
  },
  setup() {
    return {
      routeMeta: useRouteMeta(),
      faqStore: useFaqStore(),
      Themes,
    }
  },
  computed: {
    featuredCampaign(): Nullable<Campaign> {
      return this.routeMeta.meta?.featuredCampaign ?? null
    },
  },
})
</script>

<template>
  <BannerLayoutProvider />

  <QuickLinksCard />

  <LatestWinnersSection />

  <StatsBanner />

  <HomeSection />

  <SectionGuard section="as-seen-in">
    <AsSeenInBanner />
  </SectionGuard>

  <SectionGuard section="benefits">
    <ProductOverviewSection id="product-overview-section" />
  </SectionGuard>

  <PlansSection />

  <FaqView :show-breadcrumb="false" />

  <WinnersSection :title="$t('section.winners.heading')">
    <template #sub-heading>
      {{ $t('section.winners.excerpt') }}
    </template>
  </WinnersSection>

  <SponsorshipSection :display-watch-button="false" />
</template>
